/* ROUTERS  */
export const ROUTES = {
  MAIN: "/",
  LOGOUT: "/logout",
  LOGIN: "/login",
  AUTHENTICATION: "/authentication",
};

/*  Modules */
export const MODULES = {
  USERS: "Users",
  LOGOUT: "Logout",
};

/* Authentication */
export const TOKEN = 'TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER = 'USER';

export const ERROR_PAGE_TITLE = "Ôi! Đã xảy ra lỗi!";
export const ERROR_PAGE_SUBTITLE =
  "Có vẻ như hệ thống đang gặp sự cố. Vui lòng cho chúng tôi biết bạn đang làm gì khi lỗi này xảy ra. Chúng tôi sẽ khắc phục sự cố sớm nhất có thể. Xin lỗi vì bất tiện này.";
